import React, { useEffect, useState } from 'react';
import axios from 'axios';
//import styles from "./css/Card.module.css"
import { useNavigate } from "react-router-dom";

const jobs = [
  {
    id: 1,
    tripDist: "13",
    time: "12.10",
    locStart: "Punggol",
    locDest: "Jurong",
    remarks: "Please bring a food warmer bag."
  },
  {
    id: 2,
    tripDist: "9",
    time: "13.10",
    locStart: "Bedok",
    locDest: "Simei",
    remarks: "No walkers."
  },
  {
    id: 3,
    tripDist: "15",
    time: "14.10",
    locStart: "Changi",
    locDest: "Aljunied",
    remarks: "Please proceed immediately."
  }

   ];

const Delivery = () => {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = sessionStorage.getItem('jwtToken'); 
    console.log('JWT token retrieved:', token);

    
    // axios.get(`${apiUrl}/users/delivery`, 
    axios.get('http://muvitapp.com/webapp4/', 
      {
        headers: {
          "Authorization": `Bearer ${token}`,  
          
          
        }
      }
    )
    
      .then(response => {
        setMessage(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  if(sessionStorage.getItem('jwtToken')==null) {
    return(
        <p className="text-center">You need to be logged in.</p>
    )
}

  return (
    <div style={{marginTop:"1%", textAlign:"centre"}}>
      <h1>Message from Backend: {message}</h1>
      <hr/>

      <div className="container">
      <div className="row row-cols-1 row-cols-md-3 row-cols-sm-2 g-4">
        {jobs.map((job, index) => (
          <div key={index} className="col">
            <div className="card h-100">
             <div style={{marginTop:"1%", marginLeft:"3%", textAlign:"centre"}} className="card-body">
                <h5 className="card-title">{job.tripDist} {job.time}</h5>
                <h5 className="card-title">{job.locStart}</h5>
                <h5 className="card-title">{job.locDest}</h5>
                <h5 className="card-title">{job.remarks}</h5>
                
                {(
                  <div /* className={styles.allButtons} */>
                    <button
                      className="btn btn-primary"
                      onClick={(event) => {
                        event.preventDefault();
                        //navigate(`/jobdetails/${job.id}`);
                        navigate('/jobdetails');
                      }}
                      type="button"
                    >
                      Details
                    </button>

                    <hr/>
                    
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  

    </div>

    

  );
};

export default Delivery;
